import { render, staticRenderFns } from "./cityManagement.vue?vue&type=template&id=20128824&"
import script from "./cityManagement.vue?vue&type=script&lang=js&"
export * from "./cityManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports